import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const Container = styled.div `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.85);
    padding: 0.5rem;
    text-align: center;
    z-index: 9999;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`;
const Message = styled.p `
    margin: 0;
    color: #ffffff;
    font-size: 0.875rem;
    font-weight: 400;
`;
export const NotSupportedMessage = ({ children, }) => {
    return (_jsx(Container, { children: _jsx(Message, { children: children }) }));
};
export const GenericBrowserNotSupported = () => {
    return (_jsx(NotSupportedMessage, { children: "This application works best in the Chrome browser. Firefox does not yet support the underlying HEVC (H.265) or AVC (H.264) codecs used in StreamrTV." }));
};
export const CodecNotSupported = () => {
    return (_jsx(NotSupportedMessage, { children: "Your device does not support the underlying HEVC (H.265) or AVC (H.264) codecs used in StreamrTV. Support for your device is coming soon!" }));
};
